var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogArrLeftIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 10.0001C17.5005 10.1659 17.4346 10.3248 17.3174 10.442C17.2002 10.5593 17.0413 10.6251 16.8755 10.6251H4.63409L9.19268 15.1829C9.25075 15.241 9.29681 15.3099 9.32824 15.3858C9.35966 15.4617 9.37584 15.543 9.37584 15.6251C9.37584 15.7072 9.35966 15.7885 9.32824 15.8644C9.29681 15.9403 9.25075 16.0092 9.19268 16.0673C9.13461 16.1254 9.06567 16.1714 8.9898 16.2028C8.91393 16.2343 8.83261 16.2505 8.75049 16.2505C8.66837 16.2505 8.58705 16.2343 8.51118 16.2028C8.43531 16.1714 8.36637 16.1254 8.3083 16.0673L2.6833 10.4423C2.62519 10.3842 2.57909 10.3153 2.54764 10.2394C2.51619 10.1636 2.5 10.0822 2.5 10.0001C2.5 9.91797 2.51619 9.83664 2.54764 9.76077C2.57909 9.68489 2.62519 9.61596 2.6833 9.55792L8.3083 3.93292C8.42558 3.81564 8.58464 3.74976 8.75049 3.74976C8.91634 3.74976 9.0754 3.81564 9.19268 3.93292C9.30996 4.05019 9.37584 4.20925 9.37584 4.3751C9.37584 4.54096 9.30996 4.70002 9.19268 4.81729L4.63409 9.3751H16.8755C17.0413 9.3751 17.2002 9.44095 17.3174 9.55816C17.4346 9.67537 17.5005 9.83434 17.5005 10.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogArrLeftIc);
export default __webpack_public_path__ + "static/media/blogArrLeft_ic.864e81eb.svg";
export { ForwardRef as ReactComponent };